export default __webpack_public_path__ + "static/media/tag-ic.06e6c162.svg";